/**
 * What a discovery folder's creators are being sourced for. Set on the
 * folder in Discovery; the Lead queue is split by it. One definition for
 * both surfaces.
 */
export type FolderPurpose = 'clipping' | 'vyral' | 'influencer';

/** In picker order; clipping is the default. */
export const FOLDER_PURPOSES: readonly FolderPurpose[] = ['clipping', 'vyral', 'influencer'];

export const FOLDER_PURPOSE_LABELS: Record<FolderPurpose, string> = {
  clipping: 'Clipping',
  vyral: 'Vyral',
  influencer: 'Influencer',
};

/** A purpose from the server or the URL; clipping when missing or unknown. */
export function folderPurposeOf(value: string | null | undefined): FolderPurpose {
  return FOLDER_PURPOSES.includes(value as FolderPurpose) ? (value as FolderPurpose) : 'clipping';
}

/** A filter value: a purpose, or '' for every purpose. */
export function purposeFilterOf(value: string | null | undefined): FolderPurpose | '' {
  return FOLDER_PURPOSES.includes(value as FolderPurpose) ? (value as FolderPurpose) : '';
}
